var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"soliqIframe",staticClass:"iframe",attrs:{"src":"https://my3.soliq.uz/individual/cabinet/find-tin/home"}})}
var staticRenderFns = []

export { render, staticRenderFns }